/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_StarredInputs */



/**
* | output |
* | --- |
* | "Starred" |
*
* @param {Explorer_Nav_StarredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_starred = /** @type {((inputs?: Explorer_Nav_StarredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_StarredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Favoris")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit Sternchen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Con stella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отмечено звездочкой")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sembrado de estrellas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("星标")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スター付き")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तारांकित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Estrelado")
	return /** @type {LocalizedString} */ ("Starred")
});